import { useOrgUsersEntry } from '@stores/orgUserStore';

const useOrgUsers = (orgId?: string) => {
    const {
        response: orgUsers,
        isLoading: isLoadingOrgUsers,
        error: orgUsersError,
        requestApiCall: fetchOrgUsers,
    } = useOrgUsersEntry(orgId);

    return {
        orgUsers: orgUsers ?? [],
        isLoadingOrgUsers,
        orgUsersError,
        fetchOrgUsers,
    };
};

export default useOrgUsers;
